import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { adminUsersKeys, getPlatformDirectory } from '../api/admin-users'
import { USE_REAL_API } from './api'
import { usePriceMaskStore } from './price-mask'
import { useMe } from './useMe'
import { useOrgContextStore } from '../store/orgContext'

// Mounted once by the seller shell: mirrors /auth/me prices_hidden into the
// price-mask store the currency formatters read. While a PEXIFY admin views a
// seller store, it mirrors that store's Owner instead (the server masks those
// reads too), so the admin sees what the Owner sees.
export function usePriceMaskSync() {
  const { me, pricesHidden } = useMe()
  const { mode, viewing } = useOrgContextStore()
  const setHidden = usePriceMaskStore((s) => s.setHidden)
  const viewingSeller = USE_REAL_API && mode === 'platform_viewing' && viewing?.side === 'seller'
  const directory = useQuery({
    queryKey: adminUsersKeys.directory,
    queryFn: getPlatformDirectory,
    enabled: viewingSeller,
    staleTime: 60_000,
  })
  const viewedOwnerHidden =
    viewingSeller &&
    Boolean(
      directory.data?.users.some(
        (u) =>
          u.org_id === viewing?.orgId &&
          u.tier === 'owner' &&
          u.status === 'active' &&
          u.prices_hidden === true,
      ),
    )
  useEffect(() => {
    if (me !== undefined || !USE_REAL_API) setHidden(Boolean(pricesHidden) || viewedOwnerHidden)
  }, [me, pricesHidden, viewedOwnerHidden, setHidden])
  useEffect(() => () => setHidden(false), [setHidden])
}
